import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

const upsertMeta = (selector, attribute, value) => {
    const element = document.querySelector(selector);
    element?.setAttribute(attribute, value);
};

const SiteMetadata = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();

    useEffect(() => {
        const language = (i18n.resolvedLanguage || i18n.language).startsWith("en") ? "en" : "fi";
        const canonicalUrl = `${window.location.origin}${location.pathname}`;
        const imageUrl = `${window.location.origin}/images/oma_kuva.webp`;

        document.documentElement.lang = language;
        document.title = t("metadata.title");

        upsertMeta('meta[name="description"]', "content", t("metadata.description"));
        upsertMeta('meta[property="og:title"]', "content", t("metadata.title"));
        upsertMeta('meta[property="og:description"]', "content", t("metadata.description"));
        upsertMeta('meta[property="og:url"]', "content", canonicalUrl);
        upsertMeta('meta[property="og:image"]', "content", imageUrl);
        upsertMeta('meta[property="og:locale"]', "content", language === "fi" ? "fi_FI" : "en_US");
        upsertMeta('meta[name="twitter:title"]', "content", t("metadata.title"));
        upsertMeta('meta[name="twitter:description"]', "content", t("metadata.description"));
        upsertMeta('meta[name="twitter:image"]', "content", imageUrl);
        upsertMeta('link[rel="canonical"]', "href", canonicalUrl);
    }, [i18n.language, i18n.resolvedLanguage, location.pathname, t]);

    return null;
};

export default SiteMetadata;
